import type { ReactNode } from 'react';
import { UxVersionContext, type UxVersion } from './uxVersion';

/** Fournit la version d'interface à l'arbre monté (cf. uxVersion.ts). */
export function UxVersionProvider({ version, children }: { version: UxVersion; children: ReactNode }) {
  return <UxVersionContext.Provider value={version}>{children}</UxVersionContext.Provider>;
}
